import { render } from "./TechnicalYellowPage.vue?vue&type=template&id=156f8489&scoped=true"
import script from "./TechnicalYellowPage.vue?vue&type=script&lang=js"
export * from "./TechnicalYellowPage.vue?vue&type=script&lang=js"

import "./TechnicalYellowPage.vue?vue&type=style&index=0&id=156f8489&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-156f8489"]])

export default __exports__
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator,QBtn});
